/**
 * URL utility functions for generating correct production URLs
 * This ensures links work correctly when shared from preview environments
 */

export const getCrmBaseUrl = (): string => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    // Check for ALL preview/development environments
    if (
      hostname.includes('lovable.app') || 
      hostname.includes('lovableproject.com') ||
      hostname === 'localhost' || 
      hostname === '127.0.0.1'
    ) {
      return 'https://crm.greenvision.energy';
    }
  }
  return window.location.origin;
};

export const getProjectUrl = (projectId: string): string => {
  return `${getCrmBaseUrl()}/crm/projects/${projectId}`;
};

export const getBusinesscaseUrl = (projectId: string): string => {
  return `${getCrmBaseUrl()}/crm/projects/${projectId}/businesscase`;
};
